import { useTheme } from '@emotion/react'
import Head from 'next/head'
import { NextSeo } from 'next-seo'
import { isNil } from 'ramda'

import type { SharedSeoComponent } from '@twisto/api-cms'

export const Seo = ({
  metaDescription,
  metaTitle,
  structuredData,
  noIndex = false,
  canonicalURL,
  seoSocials,
  metaImage,
}: SharedSeoComponent) => {
  const theme = useTheme()
  const ogImage = metaImage?.data?.attributes

  return (
    <>
      <NextSeo
        canonical={canonicalURL}
        description={metaDescription}
        noindex={noIndex}
        openGraph={{
          title: seoSocials?.title,
          description: seoSocials?.description,
          images: ogImage && [
            {
              url: ogImage.url ?? '',
              width: ogImage.width,
              height: ogImage.height,
              alt: ogImage.alternativeText,
            },
          ],
        }}
        themeColor={theme.palette.background.primary}
        title={metaTitle}
      />
      {!isNil(structuredData) && (
        <Head>
          <script
            dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
            type="application/ld+json"
          ></script>
        </Head>
      )}
    </>
  )
}
